"use client";

import { Upload, Eye, RefreshCw, ClipboardCheck, BarChart3, HeadphonesIcon } from "lucide-react";
import CardSlider from "@/components/public/CardSlider";

interface PlatformCard {
  id: string;
  icon: React.ReactNode;
  title: string;
  body: string;
  details?: string[];
}

const platformCards: PlatformCard[] = [
  {
    id: "upload",
    icon: <Upload className="w-6 h-6" />,
    title: "Upload your properties",
    body: "Add your portfolio once and set unit level standards, product lists, delivery preferences, and turnover rules. Everything is structured so your team can run repeatable turnovers at scale."
  },
  {
    id: "manage",
    icon: <Eye className="w-6 h-6" />,
    title: "Manage remotely, in real time",
    body: "Monitor every property turnover with live status updates and portfolio wide visibility across all units. See what is scheduled, what is in progress, what is completed, and what needs attention."
  },
  {
    id: "replenish",
    icon: <RefreshCw className="w-6 h-6" />,
    title: "Replenish with verified usage",
    body: "Track consumables and linen usage by unit and trigger replenishment before stock runs low. Automated ordering reduces stockouts, waste, and emergency purchases while keeping supply consistent."
  },
  {
    id: "turnovers",
    icon: <ClipboardCheck className="w-6 h-6" />,
    title: "Run turnovers with proof, not assumptions",
    body: "Assign and track turnover tasks, capture proof of completion, and record an audit trail for standards verification. Exceptions are surfaced immediately so issues are resolved before the next guest."
  },
  {
    id: "reporting",
    icon: <BarChart3 className="w-6 h-6" />,
    title: "Reporting that operators actually use",
    body: "Measure performance across your portfolio with reporting on turnover completion, exceptions, time to resolution, standards verification, usage, waste, cost per turnover, and delivery performance."
  },
  {
    id: "support",
    icon: <HeadphonesIcon className="w-6 h-6" />,
    title: "Operations support, built in",
    body: "Your team has access to the Replenico operations team for onboarding, day to day support, and escalation handling. We help you set standards and maintain predictable outcomes as you scale."
  }
];

export function PlatformShowcase() {
  return (
    <CardSlider
      header={{
        eyebrow: "Platform",
        title: "Turnover management and replenishment, run from one portal"
      }}
      showNumbers={false}
      fullWidthCards={true}
      items={platformCards.map(card => ({
        id: card.id,
        title: card.title,
        body: card.body,
        icon: card.icon
      }))}
    />
  );
}
